import React from 'react';
export function TrophyIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.048 2C5.469 2 5 2.47 5 3.048V5H4a2 2 0 00-2 2v3.344a2 2 0 001.203 1.835l3.682 1.6A6.985 6.985 0 0011 15.929V20H6a1 1 0 100 2h12a1 1 0 100-2h-5v-4.07a6.985 6.985 0 004.115-2.151l3.682-1.6A2 2 0 0022 10.343V7a2 2 0 00-2-2h-1V3.048C19 2.469 18.53 2 17.952 2H6.048zm-.79 8.891A7.005 7.005 0 015 9V7H4v3.344l1.258.547zM7 6.005V9a5 5 0 0010 0V4H7v2.005zm13 4.34l-1.259.546A7.006 7.006 0 0019 9V7h1v3.344z"
  }));
}